import React, { useState } from 'react'
import axios from 'axios'
import { ADDRESSES, FinancePDFFolder} from '../routes/addresses'
import { useEffect } from 'react'
import { BASE_URL } from "../routes/config";
import { PieChart } from '@mui/x-charts';

import fin_19 from "../Assets/images/fin_download/FA_19-20.pdf";
import fin_20 from "../Assets/images/fin_download/FA_20-21.pdf";
import fin_21 from "../Assets/images/fin_download/FA_21-22.pdf";
import fin_22 from "../Assets/images/fin_download/FA_22-23.pdf";
import fin_23 from "../Assets/images/fin_download/FA_23-24.pdf";
import useFetchFinancePaddy from '../Hooks/API/useFetchFinancePaddy';


function BusinessFinancial(
    {
    wordCount
    }
) {

  // const [getBusinessFinancialData, setBusinessFinancialData] = useState([]);
  const { getPageData, loading } = useFetchFinancePaddy('/Wapi/financelst');

  // const fetchdata = ()=>{

  //   axios.post(`${BASE_URL}/wapi/getdoclist`,
  //  {
  //    auth_key:"xxxxx",
  //    doc_type: 3
  //  }
  //  // ,
  //  // {
  //  //     headers: {
  //  //         Authorization: loginData.token,
  //  //     },
  //  // }
  //  ).then(res => {

  //   if(res.status == '200'){
       
  //      if(res.data.suc > 0){
  //       setBusinessFinancialData(res?.data?.msg);
  //         //  setPageTitle(res.data.title);
  //         //  setFolderLocation(res?.data?.folder_name)
  //          // setFolderLocation()
  //         //  console.log(res , 'uuuuuuuuuuuuuuuuuuuuuu', res?.data?.msg);
  
  //          // pageDataCheck = res.data.status;
  //      } else {
  //       //  setPageData([0])
  //        setBusinessFinancialData([0])
  //        // pageDataCheck = res.data.status;
  //      }
  
  //      }
  
  //  }) 
  
  // }

   function limitWords(content, wordLimit) {
    const words = content?.split(' ');
    if (words.length > wordLimit) {
    return words.slice(0, wordLimit).join(' ') + '...';
    }
    return content;
    }




   useEffect(()=>{
    // fetchdata();
   },[])

    // const gstSettings = await handleGetGst();

  return (
    <>

<div className="statistic">
 
	<div className="statistic_left">

    <ul className='financeData'>
    {!loading && getPageData?.length > 0 ? (
    getPageData.map((item, index) => (
    <li key={index}>
    {item?.subject}
    <span><a href={BASE_URL + '/' + FinancePDFFolder + item?.file_name} target='_blank' rel="noreferrer">
    <i class="fa fa-file-pdf-o" aria-hidden="true"></i>  Download
    </a></span>
    </li>
    ))
    ) : (
    <li>Loading data...</li>
    )}
      
    </ul>
   
    </div>

    {/* <div className="statistic_right">
  <PieChart
  colors={['#e6b12e', '#6694c6', '#5ec384']} // Use palette
      series={[
        {
          data: [
            { id: 0, value: 10, label: 'series A' },
            { id: 1, value: 15, label: 'series B' },
            { id: 2, value: 20, label: 'series C' },
          ],
        },
      ]}
      width={400}
      height={200}
    />
		
    
	</div> */}

    </div>

    {/* {getBusinessFinancialData?.map(item=> */}
    
    {/* {limitWords(item?.doc_title, wordCount)} */}
    
    {/* )} */}
    </>
  )
}

export default BusinessFinancial